import React from 'react'
import {Link} from 'react-router-dom'
import { formatDistanceToNow } from 'date-fns'
import Paginate from 'components/paginate'
import user, {User, users} from './user'
import FeedEditor, {feedTypes} from './feed-editor'


export class Feed extends React.Component {
	renderPhoto() {
		const {feed} = this.props;
		const img = <img key='b' src={feed.href} alt=""/>;

		return !feed.htmled
			? img
			: <Link key='b' to={"/home/feed/" + feed.id}>{img}</Link>;
	}

	renderVideo() {
		return (
			<iframe
				key='b'
				width="100%" height="349"
				src={this.props.feed.href + '?autoplay=0'}
				frameBorder="0"
				allowFullScreen
			/>
		);
	}

	renderNews() {
		return <img key='b' src={this.props.feed.href} alt=""/>
	}

	renderFile() {
		const {feed} = this.props;

		return (
			<a key='b' target="_blank" href={feed.href} className="link">
				<em className="la la-cloud-download-alt" />
				<span>{feed.attachname}</span>
			</a>
		);
	}

	renderActions() {
		const {feed} = this.props;
		const owner = feed.userid == hp.store.uid;
		const actions = [];

		if (owner && this.props.onEditFeed) {
			actions.push(
				<button key='e' type="button" className="dropdown-item" onClick={this.props.onEditFeed}>
					<em className="la la-pencil" />
					<span>{__('attrs_edit')}</span>
				</button>
			);
		}
		if (actions.length == 0) {
			return null;
		}
		return (
			<div className="actions dropdown">
				<button className="btn btn-light btn-circular" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-display="static">
					<em className="la la-ellipsis-h" />
				</button>
				<div className="dropdown-menu dropdown-menu-right">
					{actions}
				</div>
			</div>
		);
	}

	onShareLinkedin(feed) {
		const linkedin_share = feed.type == 2 ? feed.href : (hp.settings.dns + "custompages/feed/" + feed.id);
		const url = "https://www.linkedin.com/shareArticle?mini=true&summary=&title=" + "&url=" + linkedin_share;
		window.open(url, 'sharer', 'toolbar=0,status=0,width=548,height=425');
	}

	onShareFacebook(feed) {
		const href = feed.type == 2 ? feed.href : (hp.settings.dns + "custompages/feed/" + feed.id);
		//const href = hp.settings.dns + 'custompages/feed/' + feed.id;
		window.open('https://www.facebook.com/sharer.php?u=' + href, 'sharer', 'toolbar=0,status=0,width=548,height=425');
	}

	onShareTwitter(feed) {
		const href = feed.type == 2 ? feed.href : (hp.settings.dns + "custompage/feed/" + feed.id);
		const doc = (new DOMParser()).parseFromString(feed.comment, 'text/html');
		let d = doc.querySelector('p');

		if (d && !d.textContent) {
			d = Array.prototype.find.call(doc.querySelectorAll('p'), n => n.textContent != '')
		}
		window.open('https://twitter.com/intent/tweet?text=' + encodeURIComponent(d && d.textContent ? d.textContent : feed.comment.replace(/(<([^>]+)>)/gi, "")) + '&url=' + href);
	}

	onLike() {
		if (!user.isLoggedIn()) {
			return mbox.info(
				<div>
					<a href='https://www.ccila-portugal.com/pt/socios/seja-socio' target="_blank">{__('socials_partner_makeme')}</a>
				</div>,
				' '
			);
		}
		const {feed} = this.props;
		if (!feed.likes) {
			feed.likes  = {};
		}
		// se user clicou num dos seus feeds, mostra esses users
		if (feed.userid == user.main.uid) {

		}
		else {
			const toogleLike = () => {
				if (feed.likes.hasOwnProperty(user.main.uid)) {
					delete feed.likes[user.main.uid];
					return 0;
				}
				return feed.likes[user.main.uid] = 1;
			};
			let value = toogleLike();

			this.forceUpdate();
			// gravar. Se der erro, repor o valor anterior
			http.post('/home/setLike.json', {fid: feed.id, value: value}, (response, success) => {
				if (!success || response.ok == 0) {
					toogleLike();
					this.forceUpdate();
				}
			})
		}
	}

	render() {
		const { feed } = this.props;
		const usr = users[feed.userid];
		if (!usr) {
			return null;
		}
		const uname = usr.profile.abbreviated_name || usr.profile.name;
		const usr_info =
			<div className="fb-header">
				<Link to={"/home/profile" + (usr.profile.id === hp.store.uid ? '' : ('/' + usr.profile.id))}  className="logo" title={uname}>
					<img src={usr.logo} alt="" />
					<div className="info">
						<span className="name" title={usr.profile.name}>{uname}</span><br/>
						{hp.store.config.show_post_date == 1
							? <span className="time">{formatDistanceToNow(feed.updated_at, hp.settings.current_locale)}</span>
							: null
						}
					</div>
				</Link>
			</div>
		const render_name = 'render' + User.renders[feed.type];
		const shares = [
			<a key="in" className="dropdown-item" onClick={this.onShareLinkedin.bind(this, feed)}>
				<em className="la la-linkedin" />
				<span>linkedin</span>
			</a>,
			<a key="f" className="dropdown-item" onClick={this.onShareFacebook.bind(this, feed)}>
				<em className="la la-facebook" />
				<span>facebook</span>
			</a>,
			<a key="t" className="dropdown-item" onClick={this.onShareTwitter.bind(this, feed)}>
				<em className="la la-twitter" />
				<span>twitter</span>
			</a>
		];
		/*
		if (usr.profile.id !== hp.store.uid) {
			shares.unshift(
				<a key="my" className="dropdown-item" href="#">
					<em className="la la-share-square" />
					<span>{__('socials_my_page')}</span>
				</a>
			)
		}
		*/
		//const comment = feed.comment.split('\n').map((text, i) => <p key={i}>{text}</p>)
		const content = [
			this[render_name](),
			<div key='a' className="descr">
				{feed.type != 4 || this.props.showDetails
					? <div dangerouslySetInnerHTML={{__html: feed.comment}} />
					: <Link to={"/home/feed/" + feed.id} className="go" dangerouslySetInnerHTML={{__html: feed.comment}} />
				}
			</div>
		];
		let likes = null;

		return (
			<div className="fb-block" key={feed.id}>
				{usr_info}
				{this.renderActions()}
				<div className="clearfix" />
				{feed.title ? <div>{feed.title}</div> : null}
				{this.props.showDetails
					? <div className="fb-body">{content}</div>
					: (feed.htmled || feed.type == 4
						? <div className="fb-body">{content}</div>
						: <Link to={"/home/feed/" + feed.id} className="fb-body">{content}</Link>
					)}
				<div className="fb-footer">
					<div className="btn-group btn-group-sm float-left">
						<button
							className={"btn btn-" + ((feed.likes || {}).hasOwnProperty(user.main.uid) ? "like" : "light")}
							onClick={this.onLike.bind(this)}
							>
							<em className="la la-thumbs-up pointer"></em>
							<span>{__('socials_like')}</span>
						</button>
						{feed.likes
							?	<button className="btn btn-light">
								<span>{Object.keys(feed.likes).length}</span>
							</button>
							:	null}
					</div>
					<div className="btn-group btn-group-sm float-right">
						<button className="btn btn-light dropdown-toggle" data-toggle="dropdown">
							<em className="la la-share" />
							<span>{__('buttons_share')}</span>
						</button>
						<div className="dropdown-menu">
							{shares}
						</div>
					</div>
				</div>
			</div>
		)
	}
}


export default class FeedComponent extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			uid: null,
			user: null,
			model: null,
			isLoaded: false
		}
		this.addPub = this.addPub.bind(this)
		this.onCloseEditor = this.onCloseEditor.bind(this)
	}

	loadFeed(next = 0, props = null) {
		if (this.state.isLoaded && next == 0) {
			return;
		}
		const {uid} = props || this.props;
		//const usr = this.state.user;

		this.state.isLoaded = true;
		if (!this.state.user || this.state.user.uid != uid || next > 0) {
			user.loadFeed(uid, next).then(usr => {
				this.setState({
					uid: uid,
					user: usr
				});
				if (this.props.onUpdate) {
					this.props.onUpdate();
				}
			});
		}
	}

	componentWillReceiveProps(props) {
		if (this.state.uid != props.uid || props.filter != hp.store.feed_filter) {
			hp.store.feed_filter = props.filter;
			this.state.isLoaded = false;
		}
		this.loadFeed(0, props);
	}

	componentDidMount() {
		this.loadFeed();
	}

	componentWillUpdate() {
		if (this.observer) {
			this.observer.disconnect()
		}
	}

	componentDidUpdate() {
		this.loadFeed();
		if (this.refs.flast) {
			if (!this.observer) {
				this.observer = new IntersectionObserver(entries => {
					if (entries[0].isIntersecting) {
						this.loadFeed(1)
					}
				})
			}
			if (user.hasMoreFeeds(this.props.uid)) {
				this.observer.observe(this.refs.flast)
			}
		}
	}

	/*
	static getDerivedStateFromProps(nextProps, prevState) {
		return nextProps.uid !== prevState.uid ? {isLoaded: false, uid: nextProps.uid} : null;
	}
	*/

	addPub() {
		this.setState({model: this.state.user.createModel(1)});
	}

	addFoto() {
		this.setState({model: this.state.user.createModel(1)});
	}

	addVideo() {
		this.setState({model: this.state.user.createModel(2)});
	}

	addNews() {
		this.setState({model: this.state.user.createModel(3, null)});
	}

	onEditFeed(feed) {
		this.setState({model: feed});
	}

	onCloseEditor() {
		this.setState({model: null});
	}

	render() {
		const edt = this.props.editable && user.canEditProfile(this.props.uid || 0);
		const usr = this.state.user
		let feed;

		if (usr) {
			if (usr.feed.length == 0) {
				feed = (
					<div className="col">
						<div className=	"alert none">
							<em className="la la-exclamation-circle" />
							<span>{__('socials_pub_none')}</span>
						</div>
					</div>
				)
			}
			else if (this.props.pagination) {
				feed =
					<Paginate
						items={usr.feed.data}
						itemsPerPage={12}
						itemCount={usr.meta.item_count}
						classNameEl="col-sm col-lg-4 my-2"
						renderItem={ feed => <Feed feed={feed} onEditFeed={this.onEditFeed.bind(this, feed)} />}
						paginationContainer={page_nav =>
							<div key="pc" className="col-sm-12 pagination-container feed-pagination">
								{page_nav}
							</div>
						}
						previousLabel={<span><em className="la la-angle-left" />{__('buttons_prev')}</span>}
						nextLabel={<span>{__('buttons_next')}<em className="la la-angle-right" /></span>}
						pageChanging={page => usr.update(1)}
					/>
			}
			else {
				const has_more = usr.feed.length < usr.meta.item_count
		
				feed = [];
				for (let i = 0, l = usr.feed.length - 1; i <= l; i ++) {
					const card = <Feed feed={usr.feed.data[i]} onEditFeed={this.onEditFeed.bind(this, usr.feed.data[i])} />
		
					if (i == l && has_more) {
						feed.push( <div key={i} ref="flast" className="col-sm col-lg-4 my-2">{card}</div> )
					}
					else {
						feed.push( <div key={i} className="col-sm col-lg-4 my-2">{card}</div> )
					}
				}
			}
			feed =
				<div className={classNames("row mx-0 feed", usr.feed.length > 0 ? "row-cols-sm-2" : null)}>
					{feed}
					{/*<Feed feed={usr.getFeed()} onEditFeed={this.onEditFeed.bind(this)} />*/}
				</div>
		}
		else {
			feed = <div className="row mx-0 row-cols-sm-2 feed" />;
		}
		const actions = edt ?
			<div className='row mx-0'>
				<div className="col feed-actions">
				{/*
				<li className="btn btn-light" onClick={this.addFoto.bind(this)}>
					<em className="la la-plus" />
					{feedTypes[1].title}
				</li>
				<li className="btn btn-light" onClick={this.addVideo.bind(this)}>
					<em className="la la-plus" />
					{__('socials_video')}
				</li>
				<li className="btn btn-light" onClick={this.addNews.bind(this)}>
					<em className="la la-plus" />
					{__('socials_news')}
				</li>
				*/}
				<button className="btn btn-light" onClick={this.addPub}>
					<em className="la la-plus" />
					{__('socials_pub_new')}
				</button>
				</div>
			</div>
			: null;

		return (
			<div>
				{this.state.model ? <FeedEditor model={this.state.model} user={this.state.user} onClose={this.onCloseEditor} /> : null}
				{actions}
				{feed}
			</div>
		)
	}
}